import { useCallback } from 'react';

// Attempts to restore the behavior that was present when react-use-form v5
// was in use. Specifically, this only returns the first error per field.
export const useYupValidationResolver = (validationSchema, validationContext) =>
  useCallback(
    async (data) => {
      try {
        const values = await validationSchema.validate(data, {
          abortEarly: false,
          context: validationContext,
        });
        return {
          values,
          errors: {},
        };
      } catch (errors) {
        if (!errors.inner) {
          // Many of the custom validators don't expect missing fields so we silently ignore all failures here.
          return { values: {}, errors: {} };
        }
        const byField = Object.groupBy(errors.inner, ({ path }) => path);
        const onlyFirst = Array.from(Object.values(byField), ([first]) => first);
        return {
          values: {},
          errors: onlyFirst.reduce(
            (allErrors, currentError) => ({
              ...allErrors,
              [currentError.path]: {
                type: currentError.type ?? 'validation',
                message: currentError.message,
              },
            }),
            {},
          ),
        };
      }
    },
    [validationSchema, validationContext],
  );
